export default __webpack_public_path__ + "static/media/ellipseRight.1240827b.svg";